import { render, staticRenderFns } from "./cDocumentDashboard.vue?vue&type=template&id=fcca3c8c&scoped=true"
import script from "./cDocumentDashboard.vue?vue&type=script&lang=js"
export * from "./cDocumentDashboard.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDashboard.vue?vue&type=style&index=0&id=fcca3c8c&prod&scoped=true&lang=scss"
import style1 from "./cDocumentDashboard.vue?vue&type=style&index=1&id=fcca3c8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcca3c8c",
  null
  
)

export default component.exports